module.exports = __webpack_public_path__ + "img/socials-group.e366f96c.svg";